<template>
    <div id="addressInputModal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Edit Address</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <input type="text" class="form-control form-control-sm" v-model="address" placeholder="Address">
                    <input type="text" class="form-control form-control-sm" v-model="city" placeholder="City">
                    <select id="patient_state" class="custom-select custom-select-sm" v-model="state">
                        <option disabled value="" hidden>Choose State</option>
                        <option v-for="state in states" :key="state.code" :value="state.code" v-text="state.name"></option>
                    </select>
                    <input type="text" class="form-control form-control-sm" v-model="postal_code" placeholder="Postal Code">
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" @click="update()">Save</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>    
</template>

<script>
export default {
    props: {
        states: Array
    },
    data() {
        return {
            addressType: null,
            address: null,
            city: null,
            state: null,
            postal_code: null,
            callback: null
        }
    },
    methods: {
        show: function (addressType, value, callback) {
            this.addressType = addressType;
            this.address = value.address;
            this.city = value.city;
            this.state = value.state;
            this.postal_code = value.postal_code;
            this.callback = callback;
            $('#addressInputModal').modal('show');
        },
        update: function () {
            this.callback(
                this.addressType,
                {                
                    address: this.address,
                    city: this.city,
                    state: this.state,
                    postal_code: this.postal_code
                }
            );
            $('#addressInputModal').modal('hide');
        }
    },
    created() {
        eventHub.$on('show-address-input-modal', this.show);
    }
}
</script>

<style scoped>
    .form-control-sm {
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
    }
</style>